/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Nav_P_Autopilot_DInputs */

const en_mk_nav_p_autopilot_d = /** @type {(inputs: Mk_Nav_P_Autopilot_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recurring work that runs on a schedule.`)
};

const id_mk_nav_p_autopilot_d = /** @type {(inputs: Mk_Nav_P_Autopilot_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pekerjaan berulang yang jalan sesuai jadwal.`)
};

/**
* | output |
* | --- |
* | "Recurring work that runs on a schedule." |
*
* @param {Mk_Nav_P_Autopilot_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_nav_p_autopilot_d = /** @type {((inputs?: Mk_Nav_P_Autopilot_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Nav_P_Autopilot_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_nav_p_autopilot_d(inputs)
	return en_mk_nav_p_autopilot_d(inputs)
});